<div class="loader-container" id="loader-container">
  <div class="loader"></div>
</div>